import type { CountryIso, Passport } from "~/types";

interface Options<Exc extends keyof Passport> {
  exclusions?: Exc[];
}

export default function passportFactory<Exc extends keyof Passport = never>(baseCountry: CountryIso, options: Options<Exc> = {}): Omit<Passport, Exc> {
  const passport = {
    nationality: baseCountry,
    lastName: '',
    firstName: '',
    sex: 'm',
    dateOfBirth: '',
    countryOfBirth: baseCountry,
    number: '',
    dateOfIssue: '',
    dateOfExpiry: '',
    placeOfIssue: baseCountry
  };
  options.exclusions?.forEach(key => delete passport[key]);
  return passport as Omit<Passport, Exc>;
}